export type ResponsibleUnit = {
  visibleName?: string;
  name?: string;
  addressString?: string;
  street?: string;
  number?: string;
  complement?: string;
  neighborhood?: string;
  city?: string;
  state?: string;
  postalCode?: string;
};

export const unitAddressValues = (unit: ResponsibleUnit) => {
  const generatedAddress = [
    [unit.street, unit.number].filter(Boolean).join(", "),
    unit.complement,
    unit.neighborhood,
    [unit.city, unit.state].filter(Boolean).join(" - "),
    unit.postalCode,
  ].filter(Boolean).join(" · ");

  return unit.addressString?.trim() || generatedAddress;
};
